module.exports = __webpack_public_path__ + "static/media/vocals.36f4e887.mp3";